<div class="cmx-icon-information-rounded-fill {{customColor}}">
  {{ text | translate }}
</div>
